import React from 'react';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

/**
 * Component for displaying loading state
 */
export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Загрузка данных...',
  className = '',
}) => {
  return (
    <div
      className={`min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 pb-20 flex items-center justify-center ${className}`}
    >
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};
